import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
function AdvertisePayment({ open, isopen }) {
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative w-full max-w-4xl mx-auto my-6 h-[60vh]">
          {/* Modal content */}
          <div className="relative flex flex-col w-full h-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
            {/* Header */}
            <div className="flex items-start justify-between p-4 border-b border-solid border-gray-400 rounded-t">
              <h3 className="text-2xl font-semibold text-text_color">
                Upgrade Your Plan
              </h3>
              <button
                className="w-8 h-8 p-2 bg-transparent border-2 rounded-full text-black opacity-50 flex justify-center items-center text-xl font-semibold outline-none focus:outline-none"
                onClick={() => isopen(false)}
              >
                ×
              </button>
            </div>
            {/* Body */}
            <div className="relative p-6 flex-auto overflow-y-auto">
              <div class="grid md:grid-cols-2 flex-row gap-4">
                <div className="">
                  <div className="grid grid-cols-1 gap-4">
                    <div className="bg-card_bg_color">
                      <div className="p-4">
                        <div className="flex justify-between">
                          <h2>Platinum Plan</h2>
                          <p>10,000/Year</p>
                        </div>
                        <div className="text">
                          <p>-Visibility & Reach - 40%</p>
                          <p>-Update over Phone, Email and SMS</p>
                          <p>-Boost on Search</p>
                        </div>
                      </div>
                      <div className="text-end  ">
                        <span className="bg-primaryColor text-white  py-2 px-4 rounded-br-lg">
                          Current Plan
                        </span>
                      </div>
                    </div>

                    <div className="space-y-3">
                      <p>Other Plan available for UPGRADE</p>
                      <div className="bg-card_bg_color flex justify-between items-center p-">
                        <div className="flex gap-3 mt-1 p-2">
                          <input type="radio" id="free" name="plan" />
                          <label htmlFor="free">Free</label>
                        </div>
                        <p>0 / Year</p>
                      </div>
                      <div className="bg-card_bg_color flex justify-between items-center p-">
                        <div className="flex gap-3 mt-1 p-2">
                          <input type="radio" id="PlatinumPlan" name="plan" />
                          <label htmlFor="PlatinumPlan">Platinum Plan</label>
                        </div>
                        <p>0 / Year</p>
                      </div>
                      <div className="bg-card_bg_color flex justify-between items-center  p-">
                        <div className="flex gap-3 mt-1 p-2">
                          <input type="radio" id="GoldPlan" name="plan" />
                          <label
                            htmlFor="GoldPlan"
                            className="mb-0 text-center"
                          >
                            Gold Plan
                          </label>
                        </div>
                        <p>0 / Year</p>
                      </div>
                      <div className="bg-card_bg_color flex justify-between items-center  p-">
                        <div className="flex gap-3 mt-1 p-2">
                          <input type="radio" id="SliverPlan" name="plan" />
                          <label htmlFor="SliverPlan">Sliver Plan</label>
                        </div>
                        <p>0 / Year</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="">
                  <div className="bg-card_bg_color">
                    <div className="p-4">
                      <div className="text mt-5 ">
                        <p>-Visibility & Reach - 40%</p>
                        <p>-Update over Phone, Email and SMS</p>
                        <p>-Boost on Search</p>
                      </div>
                      <div className="mt-3 ">
                        <h2 className="text-text_color text-2xl">
                          Payment Info
                        </h2>
                        <div className="flex justify-between mt-3 ">
                          <p>Current Plan balance </p>
                          <span>10,000</span>
                        </div>
                        <div className="flex justify-between">
                          <p>Pain Period</p>
                          <span>1 Year</span>
                        </div>
                      </div>
                      <hr className="mt-3" />
                      <div className="flex justify-end mt-2">
                        <p>
                          Due today: <span>10,000</span>
                        </p>
                      </div>
                      <div className="border-3 h-16 mt-5 flex justify-center items-center rounded-md">
                        <p className="text-text_color text-2xl">
                          Go to payment{" "}
                          <span>
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-1"
                            />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvertisePayment;
